import { render, staticRenderFns } from "./display-work-history-field.vue?vue&type=template&id=63ca43d1&scoped=true&"
import script from "./display-work-history-field.vue?vue&type=script&lang=js&"
export * from "./display-work-history-field.vue?vue&type=script&lang=js&"
import style0 from "./display-work-history-field.vue?vue&type=style&index=0&id=63ca43d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca43d1",
  null
  
)

export default component.exports